import classNames from 'classnames'
import Format from '../../../../shared/Format'
import { useTheme } from '@homebot/shared-ui-swashbuckle'
import { ListingMarkersSearch } from '../../../../../types/listings'
import styles from './Marker.module.scss'

export interface MarkerProps {
  listing: ListingMarkersSearch
  selectedListingId: string
  onClick: (ListingMarkersSearch) => void
}

const Marker = ({ listing, selectedListingId, onClick }: MarkerProps) => {
  const { theme } = useTheme()

  const isLightThemeType = theme.isLightThemeType
  const isDarkThemeType = !isLightThemeType

  const markerClassName = classNames(styles.baseMarker, {
    [styles.light]: isLightThemeType,
    [styles.dark]: isDarkThemeType,
    [styles.selected]: listing?.id === selectedListingId,
  })

  if (!listing) return null

  return (
    <div
      className={markerClassName}
      onClick={() => onClick(listing)}
      onKeyPress={() => onClick(listing)}
      role='button'
      tabIndex={0}
    >
      <Format.Currency abbreviate value={listing?.priceCents / 100} />
    </div>
  )
}

export default Marker
